import React from 'react'
import { Container } from 'react-bootstrap'
import Pagination from '../../components/Pagination'
import Banner from '../../components/Banner'
import Items from './items/Items'
import { useSelector } from 'react-redux'
import { selectNewHotItems } from '../../slice/itemSlice'
import Opportunities from './Opportunities'
import Icons from '../../components/icons/Icons'
import Newsletter from '../../components/newsletter/Newsletter.js'
import sale from '../../assets/sale.webp'


const OffersPage = () => {
  const items = useSelector(selectNewHotItems);

  return (
    <div className='page-wrapper bg-light'>
      <Banner img={sale}>
        <h1 className='display-5 '>Offers <span className='text-danger'>&</span> Opportunities<span className='text-danger fw-bold'>.</span></h1>
      </Banner>
      <Container fluid className='mt-5'>

        <Opportunities />
      </Container>

      <Container className='mt-5'>
        <Pagination items={items}/>
        <Items />
        <Pagination items={items}/>
        <Icons />
        <Newsletter />
      </Container>

    </div>
  )
}

export default OffersPage